import useOpeningClosingActions from '../core/hooks/useOpeningClosingActions'
import CheckingLocationPopup from 'components/popups/CheckingLocationPopup'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { GATEWAY_STATUS, GATE_STATUS, STATUS } from 'utils/constants'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { ReactComponent as MagIcon } from 'assets/magDetails.svg'
import { ReactComponent as HelpIcon } from 'assets/helpBig.svg'
import { ReactComponent as GateIcon } from 'assets/gate.svg'
import { ReactComponent as DoorIcon } from 'assets/door.svg'
import BigCircleBtn from 'components/buttons/BigCircleBtn'
import { selectConfig, selectLightTheme } from 'appSlice'
import CircleBtn from 'components/buttons/CircleBtn'
import useTranslation from 'hooks/useTranslation'
import useWarehouses from 'hooks/useWarehouses'
import usePopupState from 'hooks/usePopupState'
import { useReduxSelector } from 'store'
import Gateway from '../core/Gateway'
import Gate from '../core/Gate'
import { useRef } from 'react'
import '../style.scss'

const GateGateway = () => {
  const { pathname } = useLocation()
  const { id } = useParams<{ id: string }>()
  const config = useReduxSelector(selectConfig)
  const lightTheme = useReduxSelector(selectLightTheme)
  const { placeId, actions, placeShortAddress, placeGps } = useReduxSelector(state => selectWarehouse(state, id))
  const { status, isSending, action } = useOpeningClosingActions(placeId, actions)
  const search = useRef(window.location.search)
  const { popup, openPopup } = usePopupState()
  useWarehouses(true)

  const { push, replace, goBack } = useHistory()
  const { t } = useTranslation('entrance')

  const isGateway = pathname.includes('gateway')

  return (
    <>
      {popup === 'checkingGateLocation' && <CheckingLocationPopup
        targetPosition={(Array.isArray(placeGps) && placeGps.length === 2) ? {
          lat: Number(placeGps[0]),
          lng: Number(placeGps[1])
        } : undefined}
        callback={(success) => {
          if (success) {
            if (
              isGateway
              /* && status.gateway !== GATEWAY_STATUS.unlocked */
              && actions?.gateway?.open
            ) {
              action('gateway')

            } else if (
              !isGateway
              /* && (status.gate === GATE_STATUS.closed || status.gate === GATE_STATUS.closing) */
              && actions?.gate?.open
            ) {
              action('gate')
            }
          }
          goBack()
        }}
      />}

      <div className='entrance warehouse'>
        <div className={`entrance__main center${lightTheme ? '' : ' --shadow'}`}>
          {isGateway
            ? <Gateway status={status.gateway} />
            : <Gate status={status.gate} />}
          <div className='entrance__main__label --bottom'>{placeShortAddress}</div>
        </div>

        <div className='entrance__menu menu__main'>
          <div className='menu__buttons --top'>
            {isGateway
              ? <CircleBtn
                text={t('openGate')}
                Icon={GateIcon}
                action={() => {
                  replace(pathname.replace('gateway', 'gate'))
                }}
              />
              : <CircleBtn
                text={t('openGateway')}
                Icon={DoorIcon}
                action={() => {
                  replace(pathname.replace('gate', 'gateway'))
                }}
              />}

            <div className='buttons__col center'>
              {isGateway
                ? <BigCircleBtn
                  disabled={isSending || !actions?.gateway?.open}
                  text={t(status.gateway === GATEWAY_STATUS.closed ? 'open' : 'enterThroughGate')}
                  status={status.gateway === GATEWAY_STATUS.opened ? STATUS.succeed : STATUS.idle}
                  action={() => {
                    if (/* status.gateway === GATEWAY_STATUS.closed &&  */actions?.gateway?.open) {
                      if (config?.warehouseLocationCheckEnabled) {
                        openPopup('checkingGateLocation')
                      } else {
                        action('gateway')
                      }
                    }
                  }}
                />
                : <BigCircleBtn
                  disabled={isSending || !actions?.gate?.open}
                  text={t(status.gate === GATE_STATUS.opening ? 'opening'
                    : status.gate === GATE_STATUS.closing ? 'closing'
                      : status.gate === GATE_STATUS.opened ? 'driveThroughGate'
                        : 'open')}
                  status={status.gate?.includes('ing') ? STATUS.pending : STATUS.idle}
                  action={() => {
                    if (/* (status.gate === GATE_STATUS.closed || status.gate === GATE_STATUS.closing) &&  */actions?.gate?.open) {
                      if (config?.warehouseLocationCheckEnabled) {
                        openPopup('checkingGateLocation')
                      } else {
                        action('gate')
                      }
                    }
                  }}
                />}

              <CircleBtn
                text={t('help')}
                Icon={HelpIcon}
                action={() => {
                  push(`/help?warehouseId=${id}`)
                }} />
            </div>

            <CircleBtn
              text={t('manageMag')}
              Icon={MagIcon}
              action={() => {
                if (search.current.includes('from=mag')) goBack()
                else replace(`/warehouses/${id}`)
              }} />
          </div>
        </div>
      </div>
    </>
  )
}

export default GateGateway